let URL_API = 'api/';

export const API = {
    ACADEMIES: {
        GET_LIST_ACADEMIES: `${URL_API}academias`,
        GET_LIST_PLATAFORMAS: `${URL_API}academias/GetPlataformas`,
        GET_DELETE_IMPACT: `${URL_API}academias/DeleteImpact`
      // MODIFY_LIST_ACADEMIES: `${URL_API}academias`,
    },
    MATERIAS: {
        GET_LIST_MATERIAS: `${URL_API}materias`,
        GET_LIST_MATERIAS_ACADEMIAS: `${URL_API}materias/GetMateriasConAcademias`,
        // MODIFY_LIST_ACADEMIES: `${URL_API}academias`,
        GET_LIST_MATERIAS_DISPONIBLES: `${URL_API}Materias/GetMateriasDisponibles`,
    },
    USUARIOS: {
        GET_LIST_USUARIOS: `${URL_API}usuarios`,
      DELETE_BATCH_USUARIOS: `${URL_API}usuarios/DeleteBatch`,
        GET_LIST_ROLES: `${URL_API}usuarios/roles`,
        CHANGE_PASSWORD: `${URL_API}usuarios/ChangePassword`
        // MODIFY_LIST_ACADEMIES: `${URL_API}academias`,
    },
    LOGIN: {
      MAKE_LOGIN: `${URL_API}Usuarios/MakeLogin`,
      MAKE_LOGOUT: `${URL_API}Usuarios/MakeLogout`,
      GET_AUTHENTICATED_USER: `${URL_API}Usuarios/GetAuthenticatedUser`
    },
    EXAMENES: {
      EXAMENES: `${URL_API}Examenes`,
      GET_EXAMEN: `${URL_API}Examenes/GetExamen`,
      GET_EXAMEN_EXISTS: `${URL_API}Examenes/ExamenExists`,
      GET_EXAMENES_ACADEMIA_USUARIO: `${URL_API}Examenes/GetExamenesAcademiaUsuario`,
      UPDATE_EXAMEN: `${URL_API}Examenes/UpdateExamen`,
      GET_VISIBILIDAD_EXTERNA: `${URL_API}Examenes/GetVisibilidadExterna`,
      UPDATE_VISIBILIDAD_EXTERNA: `${URL_API}Examenes/UpdateVisibilidadExterna`,
      CHECK_EXAMEN_GUARDADO: `${URL_API}ExamenesGuardados/CheckExamenGuardadoExists`,
      GET_EXAMEN_GUARDADO: `${URL_API}ExamenesGuardados/GetExamenGuardadoUsuario`,
      POST_GUARDAR_EXAMEN: `${URL_API}ExamenesGuardados/PostGuardaExamen`,
      ELIMINAR_EXAMEN_GUARDADO: `${URL_API}ExamenesGuardados/ExamenGuardadoUsuario`,
    },
    FILE: {
      UPLOAD_FILE: `${URL_API}File/UploadExcel`
    },
    CASOS_CLINICOS: {
      GET_BY_EXAMEN: idExamen => `${URL_API}CasosClinicos/Examen/${idExamen}`,
      SAVE_BY_EXAMEN: idExamen => `${URL_API}CasosClinicos/Examen/${idExamen}/Guardar`,
      CASOS_CLINICOS: `${URL_API}CasosClinicos`,
      CASO_CLINICO: idCasoClinico => `${URL_API}CasosClinicos/${idCasoClinico}`,
      UPLOAD_EXCEL: `${URL_API}CasosClinicos/UploadExcel`,
    },
    PREGUNTAS: {
      GET_PREGUNTAS: `${URL_API}Preguntas`,
      GET_PREGUNTA: `${URL_API}Preguntas/GetPregunta`,
      GET_PREGUNTAS_EXAMENES_ACADEMIA: `${URL_API}Preguntas/GetPreguntasExamenesDisponibles`,
      POST_EXPORT_BUSCADOR_PREGUNTAS_PDF: `${URL_API}Preguntas/ExportBuscadorPdf`,
      GET_PREGUNTAS_MATERIAS_EXAMENES: `${URL_API}Preguntas/GetRecuentoMaterias`,
      POST_PREGUNTAS_FINALIZAR_EXAMEN: `${URL_API}Preguntas/PostPreguntasFinalizarExamen`,
      ADD_PREGUNTA_CON_OPCIONES: `${URL_API}Preguntas/AddPreguntaConOpciones`,
      EDIT_PREGUNTA_CON_OPCIONES: `${URL_API}Preguntas/EditPreguntaConOpciones`,
      GET_RECUENTO_MATERIAS: `${URL_API}Preguntas/GetRecuentoMaterias`,
      POST_PREGUNTAS_EXAMEN: `${URL_API}Preguntas/GetPreguntasExamen`,
      GET_PREGUNTAS_EXAMEN_REAL: `${URL_API}Preguntas/GetPreguntasExamenReal`,
      GET_PREGUNTAS_EXAMENES_ACADEMIA_CRUD: `${URL_API}Preguntas/GetPreguntasExamenesDisponiblesCrud`,
      GET_MATERIAS_ERRONEAS: `${URL_API}PreguntasErroneas/GetMateriasErroneas`,
      DELETE_ALL_PREGUNTAS_ERRONEAS: `${URL_API}PreguntasErroneas/DeleteAllPreguntasErroneas`,
      POST_PREGUNTAS_EXAMEN_ERRONEAS: `${URL_API}PreguntasErroneas/GetPreguntasExamenErroneas`,
  },
    FOROS: {
      GET_MATERIAS: `${URL_API}Foros/materias`,
      GET_HILOS_MATERIA: idMateria => `${URL_API}Foros/materias/${idMateria}/hilos`,
      GET_HILO_DETALLE: idHilo => `${URL_API}Foros/hilos/${idHilo}`,
      POST_HILO: `${URL_API}Foros/hilos`,
      POST_RESPUESTA: idHilo => `${URL_API}Foros/hilos/${idHilo}/respuestas`,
      DELETE_HILO: idHilo => `${URL_API}Foros/hilos/${idHilo}`,
      DELETE_RESPUESTA: idRespuesta => `${URL_API}Foros/respuestas/${idRespuesta}`,
    },
  }
